import {
  GET_GROUP,
  GET_GROUPS,
  ADD_GROUP,
  REMOVE_GROUPS,
  UPDATE_GROUP,
  ADD_DATA_COLLECTION_TO_GROUP,
  REMOVE_DATA_COLLECTION_FROM_GROUP,
} from "../constants/action-types";
import Axios from "axios";

import { getApiCodes, getApiConfig } from "../../config/apiConfig";
import { entityTypeToString } from "../constants/EntityType";
import { adalApiFetch } from "../../config/azureConfig";
const API_CONFIG = getApiConfig();

/*
  Get groups.
*/
export const getGroups = callback => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/productGroups`, {
    method: "get"
  }).then(res => {
    dispatch({
      type: GET_GROUPS,
      payload: res.data.productGroups
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
};

/*
  Get groups.
*/
export const getGroupsWithIds = (groupIds, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/productGroups?forIds=true`, {
    method: "post",
    data: groupIds
  }).then(res => {
    const data = res.data;

    dispatch({
      type: GET_GROUPS,
      payload: data.productGroups
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
};

/*
  Get group.
*/
export const getGroup = (groupId, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/productGroups/${groupId}`, {
    method: "get"
  }).then(res => {
    dispatch({
      type: GET_GROUP,
      payload: res.data.productGroup
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
};

/*
  Update group.
*/
export const updateGroup = (groupId, updatedData, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/productGroups/${groupId}`, {
    method: "put",
    data: updatedData
  }).then(() => {
    dispatch({
      type: UPDATE_GROUP,
      payload: { groupId, updatedData }
    });
    callback(true);
  }).catch(error => {
    console.log("Exception occurred", error);
    callback(false);
  });
};

/* 
  Add groups.
*/
export const addGroup = (group, callback) => dispatch => {
  const productGroup = {
    "id": group.id,
    "Active": true,
    "Name": group.Name,
    "IncludedProducts": [],
    "ExcludedProducts": [],
    "IncludedCategories": [],
    "ExcludedCategories": [],
    "IncludedMasterTags": [],
    "ExcludedMasterTags": [],
  }

  adalApiFetch(Axios, `${API_CONFIG.URL}/productGroups`, {
    method: "post",
    data: productGroup
  }).then(res => {
    const productGroupId = res.data;

    productGroup.id = productGroupId;

    dispatch({
      type: ADD_GROUP,
      payload: productGroup
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
};

/* 
  Remove groups.
*/
export const removeGroups = (groupIds, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/productGroups`, {
    method: "delete",
    data: groupIds
  }).then(res => {
    dispatch({
      type: REMOVE_GROUPS,
      payload: groupIds
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
};

/*
  Add entities to group.
*/
export const addEntitiesToProductGroup = (
  entityType,
  groupIds,
  entityIds,
  shouldExclude,
  callback
) => dispatch => {
  const entity = {
    entityType: entityTypeToString(entityType),
    inclusiveType: shouldExclude ? "Exclude" : "Include",
    entityIds: entityIds,
    productGroupIds: groupIds
  }

  adalApiFetch(Axios, `${API_CONFIG.URL}/productGroups/entities`, {
    method: "post",
    data: entity
  }).then(res => {
    dispatch({
      type: ADD_DATA_COLLECTION_TO_GROUP,
      payload: {
        collectionType: entityType,
        groupIds,
        entityIds,
        shouldExclude
      }
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
};

/* 
  Remove entities from group.
*/
export const removeEntitiesFromProductGroup = (
  entityType,
  groupIds,
  entityIds,
  isExcluded,
  callback
) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/productGroups/entities`, {
    method: "delete",
    data: {
      entityType: entityTypeToString(entityType),
      inclusiveType: isExcluded ? "Exclude" : "Include",
      entityIds: entityIds,
      productGroupIds: groupIds
    }
  }).then(res => {
    dispatch({
      type: REMOVE_DATA_COLLECTION_FROM_GROUP,
      payload: { collectionType: entityType, groupIds, entityIds, isExcluded }
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
};
